import { ParticipantPresenterProps } from 'features/ParticipantItem/types';
import { useSIPParticipant } from 'useCase/SIPTelephony/useSIPParticipant';
import { MobileViewerSIP } from './MobileViewerSIP';
import { MobileViewerVCS } from './MobileViewerVCS';

interface Props extends ParticipantPresenterProps {}

export const MobileViewer = (props: Props) => {
    const { checkIsSIPParticipant } = useSIPParticipant();

    const { participant } = props;
    const isSIPParticipant = checkIsSIPParticipant(participant);

    if (isSIPParticipant) {
        return <MobileViewerSIP {...props} />;
    }

    return <MobileViewerVCS {...props} />;
};
